module.exports = __webpack_public_path__ + "img/brand.08f459c3.svg";